import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import '@fontsource/roboto/400.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/merriweather/400.css';
import '@fontsource/quicksand/400.css';
import '@fontsource/pacifico/400.css';
import '@fontsource/dancing-script/400.css';
import '@fontsource/great-vibes/400.css';
import '@fontsource/lobster/400.css';
import '@fontsource/caveat/400.css';
import '@fontsource/kalam/400.css';
import '@fontsource/cinzel/400.css';
import '@fontsource/cinzel-decorative/400.css';
import '@fontsource/orbitron/400.css';
import '@fontsource/rajdhani/400.css';
import '@fontsource/press-start-2p/400.css';
import '@fontsource/permanent-marker/400.css';
import '@fontsource/bebas-neue/400.css';
import '@fontsource/righteous/400.css';
import App from './App';
import LoginPage from './pages/LoginPage';
import reportWebVitals from './reportWebVitals';
import {
  registerBackgroundAuthRenewal,
  renewSwaSession,
  scheduleBackgroundAuthRenewal,
} from './utils/swaAuth';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'sans-serif', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Check the browser console for details.</p>
          {this.state.error && <pre style={{ textAlign: 'left', overflow: 'auto' }}>{this.state.error.toString()}</pre>}
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then(async (registration) => {
        await registerBackgroundAuthRenewal(registration);
        scheduleBackgroundAuthRenewal(registration);
        renewSwaSession();
      })
      .catch((err) => console.error('Service worker registration failed:', err));
  });
}
